(ns frontend.actions.person
  (:require [frontend.conn :as conn]
            [promesa.core :as p]
            [clojure.string :as string]
            [frontend.utils :as utils]
            [frontend.logging :as logging]))

;; NOTE
;; Should be one-to-one mapping with domain/person and other related files
;; No other tasks should be performed here
;; Should only be required in `events` files
;; Function signatures should always be
;; [data on-success! on-error!]
;; Keep it Simple and Silly

(defn validate-person-fields [p mandatory-fields]
  (let [first-name (or (:person/first-name p) "")
        last-name (or (:person/last-name p) "")
        universal-email-address (:person/universal-email-address p)
        valid-name (or (> (count (string/trim first-name)) 0)
                       (> (count (string/trim last-name)) 0))
        valid-or-empty-email (or (utils/validate-email universal-email-address)
                                 ;; no need for valid email when not mandatory and no entered text
                                 (and (not (some #{:person/universal-email-address} mandatory-fields))
                                      (or (not universal-email-address)
                                          (< (count (string/trim universal-email-address)) 1))))
        valid (and (or valid-name
                       (utils/validate-email universal-email-address))
                   valid-or-empty-email)]
    valid))

(defn *->create-many [datas on-success! on-error!]
  (-> (conn/sendp! :person/create-many datas)
      (p/then on-success!)
      (p/catch on-error!)))
